import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  AutoComplete_Password_getInstanceyld5z2aqpc6v as AutoComplete_Password_getInstance,
  AutoComplete_NewPassword_getInstance1yzmcu8by4qcs as AutoComplete_NewPassword_getInstance,
} from '../../models/data.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DriverActionException1ncfunkkb5qm9 as DriverActionException } from '../DriverActionException.mjs';
import { get_overlayFrame1s8kw8rhusiwv as get_overlayFrame } from '../l2/appBase.mjs';
import {
  driverChildren2ahybtnb3gaha as driverChildren,
  driverSnapshot8nzyivxk5zsq as driverSnapshot,
} from '../DriverSupport.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  firstOrNull1982767dljvdy as firstOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { coerceIn82duc7igyjd0 as coerceIn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { Companion_getInstance3h03aipe2gus4 as Companion_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstance29buwn7hkq75x as Companion_getInstance_0 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance_1 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buttonDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('click', buttonDriverActions$slambda(tmp0_safe_receiver, _this__u8e3s4));
  }
  var tmp1_safe_receiver = _this__u8e3s4.secondaryAction_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('longClick', buttonDriverActions$slambda_0(tmp1_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function externalLinkDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  if (!(_this__u8e3s4.get_to_kntnng_k$() == null)) {
    this_0.put_4fpzoq_k$('click', externalLinkDriverActions$slambda(_this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function linkDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  if (!(_this__u8e3s4.to_1 == null)) {
    this_0.put_4fpzoq_k$('click', linkDriverActions$slambda(_this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function menuDriverActions(_this__u8e3s4, click) {
  click = click === VOID ? null : click;
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  if (click == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('click', menuDriverActions$slambda(click, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function toggleDriverValue(_this__u8e3s4) {
  return _this__u8e3s4.checked_1.get_value_j01efc_k$().toString();
}
function toggleDriverActions(_this__u8e3s4) {
  var tmp = to('toggle', toggleDriverActions$slambda(_this__u8e3s4));
  return mapOf([tmp, to('setValue', toggleDriverActions$slambda_0(_this__u8e3s4))]);
}
function numberInputDriverValue(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.content_1.get_value_j01efc_k$();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function numberInputDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', numberInputDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', numberInputDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function localDateDriverValue(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.content_1.get_value_j01efc_k$();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function localDateDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', localDateDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', localDateDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function localDateTimeDriverValue(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.content_1.get_value_j01efc_k$();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function localDateTimeDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', localDateTimeDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', localDateTimeDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function localTimeDriverValue(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.content_1.get_value_j01efc_k$();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function localTimeDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', localTimeDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', localTimeDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function textInputDriverValue(_this__u8e3s4) {
  return redactedDriverValue(_this__u8e3s4.keyboardHints_1, _this__u8e3s4.content_1.get_value_j01efc_k$());
}
function textInputDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', textInputDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', textInputDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function textAreaDriverValue(_this__u8e3s4) {
  return redactedDriverValue(_this__u8e3s4.keyboardHints_1, _this__u8e3s4.content_1.get_value_j01efc_k$());
}
function textAreaDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', textAreaDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', textAreaDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function checkboxDriverValue(_this__u8e3s4) {
  return _this__u8e3s4.checked_1.get_value_j01efc_k$().toString();
}
function checkboxDriverActions(_this__u8e3s4) {
  var tmp = to('toggle', checkboxDriverActions$slambda(_this__u8e3s4));
  return mapOf([tmp, to('setValue', checkboxDriverActions$slambda_0(_this__u8e3s4))]);
}
function radioDriverValue(_this__u8e3s4) {
  return _this__u8e3s4.checked_1.get_value_j01efc_k$().toString();
}
function radioDriverActions(_this__u8e3s4) {
  return mapOf_0(to('select', radioDriverActions$slambda(_this__u8e3s4)));
}
function switchDriverValue(_this__u8e3s4) {
  return _this__u8e3s4.checked_1.get_value_j01efc_k$().toString();
}
function switchDriverActions(_this__u8e3s4) {
  var tmp = to('toggle', switchDriverActions$slambda(_this__u8e3s4));
  return mapOf([tmp, to('setValue', switchDriverActions$slambda_0(_this__u8e3s4))]);
}
function redactedDriverValue(hints, actual) {
  var tmp;
  if (!isSecret(hints)) {
    tmp = actual;
  } else {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(actual) === 0) {
      tmp = '';
    } else {
      tmp = '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022';
    }
  }
  return tmp;
}
function isSecret(_this__u8e3s4) {
  return equals(_this__u8e3s4.autocomplete_1, AutoComplete_Password_getInstance()) || equals(_this__u8e3s4.autocomplete_1, AutoComplete_NewPassword_getInstance());
}
function formattedTextInputDriverValue(_this__u8e3s4) {
  return redactedDriverValue(_this__u8e3s4.keyboardHints_1, _this__u8e3s4.content_1.get_value_j01efc_k$());
}
function formattedTextInputDriverActions(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  this_0.put_4fpzoq_k$('setValue', formattedTextInputDriverActions$slambda(_this__u8e3s4));
  var tmp0_safe_receiver = _this__u8e3s4.action_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.put_4fpzoq_k$('submit', formattedTextInputDriverActions$slambda_0(tmp0_safe_receiver, _this__u8e3s4));
  }
  return this_0.build_nmwvly_k$();
}
function buttonDriverActions$slambda($a, $this_buttonDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_buttonDriverActions);
    return 'OK';
  }), 1);
}
function buttonDriverActions$slambda_0($a, $this_buttonDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_buttonDriverActions);
    return 'OK';
  }), 1);
}
function externalLinkDriverActions$slambda($this_externalLinkDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return 'OK: ' + $this_externalLinkDriverActions.get_to_kntnng_k$();
  }), 1);
}
function linkDriverActions$slambda($this_linkDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = $this_linkDriverActions.to_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('no navigation target on this link');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var page = tmp;
    var tmp_0;
    if ($this_linkDriverActions.resetsStack_1) {
      $this_linkDriverActions.onNavigator_1.reset_diztr_k$(page);
      tmp_0 = Unit_instance;
    } else {
      $this_linkDriverActions.onNavigator_1.navigate_sm5lxf_k$(page);
      tmp_0 = Unit_instance;
    }
    return 'OK';
  }), 1);
}
function menuDriverActions$slambda($fn, $this_menuDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $fn();
    var tmp0_safe_receiver = lastOrNull(driverChildren(get_overlayFrame($this_menuDriverActions.get_context_h02k06_k$())));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : driverSnapshot(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'opened' : tmp1_elvis_lhs;
  }), 1);
}
function toggleDriverActions$slambda($this_toggleDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_toggleDriverActions.checked_1.set_revjhg_k$(!$this_toggleDriverActions.checked_1.get_value_j01efc_k$(), $completion);
    return 'OK';
  }), 1);
}
function toggleDriverActions$slambda_0($this_toggleDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = firstOrNull(args);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toBooleanStrictOrNull(tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected true/false argument');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var v = tmp;
    yield* $this_toggleDriverActions.checked_1.set_revjhg_k$(v, $completion);
    return 'OK';
  }), 1);
}
function numberInputDriverActions$slambda($this_numberInputDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = firstOrNull(args);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected number argument');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var v = tmp;
    var tmp2_safe_receiver = $this_numberInputDriverActions.range_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = coerceIn(v, tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_0;
    var clamped = tmp3_elvis_lhs == null ? v : tmp3_elvis_lhs;
    yield* $this_numberInputDriverActions.content_1.set_revjhg_k$(clamped, $completion);
    return 'OK';
  }), 1);
}
function numberInputDriverActions$slambda_0($a, $this_numberInputDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_numberInputDriverActions);
    return 'OK';
  }), 1);
}
function localDateDriverActions$slambda($this_localDateDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected date argument (yyyy-MM-dd)');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var v = tmp;
    var tmp_0;
    try {
      tmp_0 = yield* $this_localDateDriverActions.content_1.set_revjhg_k$(Companion_getInstance().parse$default_krgov1_k$(v), $completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Exception()) {
        var e = $p;
        throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$("invalid date '" + v + "': " + e.message);
      } else {
        throw $p;
      }
    }
    return 'OK';
  }), 1);
}
function localDateDriverActions$slambda_0($a, $this_localDateDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_localDateDriverActions);
    return 'OK';
  }), 1);
}
function localDateTimeDriverActions$slambda($this_localDateTimeDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected datetime argument (yyyy-MM-ddTHH:mm:ss)');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var v = tmp;
    var tmp_0;
    try {
      tmp_0 = yield* $this_localDateTimeDriverActions.content_1.set_revjhg_k$(Companion_getInstance_0().parse$default_rpbnp3_k$(v), $completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Exception()) {
        var e = $p;
        throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$("invalid datetime '" + v + "': " + e.message);
      } else {
        throw $p;
      }
    }
    return 'OK';
  }), 1);
}
function localDateTimeDriverActions$slambda_0($a, $this_localDateTimeDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_localDateTimeDriverActions);
    return 'OK';
  }), 1);
}
function localTimeDriverActions$slambda($this_localTimeDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = firstOrNull(args);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected time argument (HH:mm or HH:mm:ss)');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var v = tmp;
    var tmp_0;
    try {
      tmp_0 = yield* $this_localTimeDriverActions.content_1.set_revjhg_k$(Companion_getInstance_1().parse$default_id2jrv_k$(v), $completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Exception()) {
        var e = $p;
        throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$("invalid time '" + v + "': " + e.message);
      } else {
        throw $p;
      }
    }
    return 'OK';
  }), 1);
}
function localTimeDriverActions$slambda_0($a, $this_localTimeDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_localTimeDriverActions);
    return 'OK';
  }), 1);
}
function textInputDriverActions$slambda($this_textInputDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    yield* $this_textInputDriverActions.content_1.set_revjhg_k$(joinToString(args, ' '), $completion);
    return 'OK';
  }), 1);
}
function textInputDriverActions$slambda_0($a, $this_textInputDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_textInputDriverActions);
    return 'OK';
  }), 1);
}
function textAreaDriverActions$slambda($this_textAreaDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    yield* $this_textAreaDriverActions.content_1.set_revjhg_k$(joinToString(args, ' '), $completion);
    return 'OK';
  }), 1);
}
function textAreaDriverActions$slambda_0($a, $this_textAreaDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_textAreaDriverActions);
    return 'OK';
  }), 1);
}
function checkboxDriverActions$slambda($this_checkboxDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_checkboxDriverActions.checked_1.set_revjhg_k$(!$this_checkboxDriverActions.checked_1.get_value_j01efc_k$(), $completion);
    return 'OK';
  }), 1);
}
function checkboxDriverActions$slambda_0($this_checkboxDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = firstOrNull(args);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toBooleanStrictOrNull(tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected true/false argument');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var v = tmp;
    yield* $this_checkboxDriverActions.checked_1.set_revjhg_k$(v, $completion);
    return 'OK';
  }), 1);
}
function radioDriverActions$slambda($this_radioDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_radioDriverActions.checked_1.set_revjhg_k$(true, $completion);
    return 'OK';
  }), 1);
}
function switchDriverActions$slambda($this_switchDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_switchDriverActions.checked_1.set_revjhg_k$(!$this_switchDriverActions.checked_1.get_value_j01efc_k$(), $completion);
    return 'OK';
  }), 1);
}
function switchDriverActions$slambda_0($this_switchDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    var tmp0_safe_receiver = firstOrNull(args);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toBooleanStrictOrNull(tmp0_safe_receiver);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw DriverActionException().new_com_lightningkite_kiteui_views_DriverActionException_z6tfwz_k$('expected true/false argument');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var v = tmp;
    yield* $this_switchDriverActions.checked_1.set_revjhg_k$(v, $completion);
    return 'OK';
  }), 1);
}
function formattedTextInputDriverActions$slambda($this_formattedTextInputDriverActions) {
  return constructCallableReference((args, $completion) => orPromise($completion, function *($completion) {
    yield* $this_formattedTextInputDriverActions.content_1.set_revjhg_k$(joinToString(args, ' '), $completion);
    return 'OK';
  }), 1);
}
function formattedTextInputDriverActions$slambda_0($a, $this_formattedTextInputDriverActions) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    $a.startAction_u0zgbm_k$($this_formattedTextInputDriverActions);
    return 'OK';
  }), 1);
}
//region block: exports
export {
  buttonDriverActions as buttonDriverActionsadt7l0sftmbu,
  checkboxDriverActions as checkboxDriverActions1pb2je1gckimy,
  checkboxDriverValue as checkboxDriverValue1fu4xhjobtexn,
  externalLinkDriverActions as externalLinkDriverActions1ec393ucdz1u1,
  formattedTextInputDriverActions as formattedTextInputDriverActions9fmp7i5lw2lt,
  formattedTextInputDriverValue as formattedTextInputDriverValue2ukph3tibkiba,
  linkDriverActions as linkDriverActionsta8m06awp14l,
  localDateDriverActions as localDateDriverActions33yza345d5yyl,
  localDateDriverValue as localDateDriverValue3efkpkqdsaql8,
  localDateTimeDriverActions as localDateTimeDriverActions1tze8b198n078,
  localDateTimeDriverValue as localDateTimeDriverValue1ntgd6qo3p0r9,
  localTimeDriverActions as localTimeDriverActions21xcjktq9vd0v,
  localTimeDriverValue as localTimeDriverValue1180sc3utfw98,
  menuDriverActions as menuDriverActionspd2q4q8dt14s,
  numberInputDriverActions as numberInputDriverActions2t0hen8ed6sic,
  numberInputDriverValue as numberInputDriverValue35s6t5zj1zqsa,
  radioDriverActions as radioDriverActions3r5vrcuo9p8fc,
  radioDriverValue as radioDriverValuersbiyzmihqhw,
  switchDriverActions as switchDriverActionsjmoklmnalzmn,
  switchDriverValue as switchDriverValuer8prxjgoi83j,
  textAreaDriverActions as textAreaDriverActions3fx3qfsuocpnn,
  textAreaDriverValue as textAreaDriverValues54empem3xft,
  textInputDriverActions as textInputDriverActions3hqh1ppdy4gus,
  textInputDriverValue as textInputDriverValue3q4tdt9119yf7,
  toggleDriverActions as toggleDriverActions4ap7fpkrm5vy,
  toggleDriverValue as toggleDriverValue7dymtxaciltl,
};
//endregion

//# sourceMappingURL=DriverOverrides.mjs.map
